setTimeout(() => {
    const loader = document.querySelector("#loader");
    loader.style.display = "none";
},4000)